import { useMemo } from 'react';
import { ColorSelector, ColorSelectorConfig } from 'dashboard409a/components/ColorSelector';
import { useJobsColorPalette } from 'dashboard409a/hooks/useJobsColorPalette';
import { JOBS_STATUS_LABELS, type JobsColorPalette } from 'dashboard409a/pages/Workboard/common/constants';
import { toSolidColor } from 'dashboard409a/utilities/colorPalette';

interface JobsColorSelectorProps {
  onClose?: () => void;
}

const JobsColorSelector = ({ onClose }: JobsColorSelectorProps = {}) => {
  const config: ColorSelectorConfig<JobsColorPalette> = useMemo(
    () => ({
      title: 'Valuations Color Palette',
      tooltip: 'Change Valuation Colors',
      useHook: useJobsColorPalette,
      statusLabels: JOBS_STATUS_LABELS,
      sections: [
        {
          title: 'Valuation Status Colors',
          keys: Object.keys(JOBS_STATUS_LABELS) as Array<keyof JobsColorPalette>,
        },
      ],
      modalWidth: '640px',
      toSolidColor,
      onClose,
    }),
    [onClose]
  );

  return <ColorSelector config={config} />;
};

export default JobsColorSelector;